import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from 'firebase/auth';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../shared/services/api.service';

import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-register',
  standalone: false,
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent {
  authForm!: FormGroup;
  showPassword = true;
  user: User | null = null;
userAForm!: FormGroup;
  userBForm!: FormGroup;
  userCForm!: FormGroup;
   
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private router: Router,
    private toastrMsgService: ToastrService
  ) { }

  ngOnInit() {
    this.initForm();
    this.checkLogIn();

    this.userAForm = this.formBuilder.group({
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: [""],
      gst_number: ["", [ Validators.required,Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$') ]],
      pan_number: ["", [ Validators.required,Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$') ]],
      city: ["", Validators.required],
      state:["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      domain: ["", Validators.required],
    });
     this.userBForm = this.formBuilder.group({
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
     });


  }
  loginWithGoogle() {
    this.userAuthService.loginWithGoogle().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  loginWithFacebook() {
    this.userAuthService.loginWithFacebook().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  logout() {
    this.userAuthService.logoutA().then(() => {
      this.user = null;
    });
  }

  initForm() {
    this.authForm = this.formBuilder.group({
      email: ['', Validators.required],
      
    });
  }

  checkLogIn() {
  
    console.log("login", this.userAuthService.getUserDetailsFromLocal())
   if (this.userAuthService.getUserDetailsFromSession()) {
      this.router.navigate(['home/dashboard'])
    }
  }
  

  get formControls() {
    return this.authForm?.controls;
  }

  signIn() {
    // if (this.authForm.invalid) {
      //   this.authForm.markAllAsTouched();
      //   return;
    // }
  var addUser= {
  "org_name": this.userAForm.value.org_name,
  "org_type": this.userAForm.value.org_type,
  "registration_number": this.userAForm.value.registration_number,
  "gst_number": this.userAForm.value.gst_number,
  "city": this.userAForm.value.city,
  "state": this.userAForm.value.state,
  "postal_code": this.userAForm.value.postal_code,
  "pan_number": this.userAForm.value.pan_number,
  "country": this.userAForm.value.country,
  "domain": this.userAForm.value.domain,
  "primary_contact_name": this.userBForm.value.primary_contact_name,
  "primary_contact_phone": this.userBForm.value.primary_contact_phone,
  "primary_contact_email": this.userBForm.value.primary_contact_email,

}

    console.log("err", addUser);
    this.userAuthService.signupEmail(addUser).subscribe({
      next: (res) => {
localStorage.setItem("email", this.userBForm.value.primary_contact_email);
        console.log(res);
        localStorage.setItem('user', JSON.stringify(res));
        localStorage.setItem('user', JSON.stringify(res));
        this.router.navigate(['onboarding/verify-email'])
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err?.error?.message);
        this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
  }
}
